module.exports = new __parcel__URL__("white-flowers.81ba80ad.png").toString();